import { NativeDatePicker } from "components/base/Form";
import { useState } from "react";
import OdooOrdersViewForFSIView from "./OdooOrdersViewForFSIView";

const ImportOdooOrdersForFSIView = () => {
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);

  return (
    <div
      className="p-10 pt-6 text-sm flex flex-col h-screen"
      // style={{ height: "calc(100vh)" }}
    >
      <div className="flex items-center space-x-6">
        <div className="flex items-center space-x-3">
          <label>FSI Order Date: </label>
          <NativeDatePicker
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />
        </div>
      </div>

      <div className="flex items-center space-x-6 mt-2 text-xs">
        <div className="flex items-center space-x-3">
          <label>Order Class: </label>
          <span>Waboba B2B</span>
        </div>

        <div className="flex items-center space-x-3">
          <label>Payment Terms: </label>
          <span>
            All except "Hold | Past Due Invoice" "Hold|need cc" and "Hold"
          </span>
        </div>

        <div className="flex items-center space-x-3">
          <label>Product Type: </label>
          <span>Only Storable</span>
        </div>
      </div>

      <div className="card p-0 flex-1 overflow-auto mt-4 -mx-1 relative">
        <OdooOrdersViewForFSIView fsiOrderDate={date} />
      </div>
    </div>
  );
};

export default ImportOdooOrdersForFSIView;
